import React, { useContext, useEffect, useState } from "react";
import "../../Styles/styles.css";
import "../../Styles/Navbar.css";
import Bag from "../../Assets/Images/Bag.png";
import Vector from "../../Assets/Images/Vector.png";
import { ButtonContainer } from "../Shared/ButtonComponent";
import AddToCart from "../../Pages/AddToCart";
import CustomStyle from "./CustomStyle";
import CustomForm from "./CustomForm";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useFormik } from "formik";
import { UserContext } from "../../context/userContext";
import useTailoring from "../../hooks/useTailoring";
import TailoringContext from "../../context/TailoringContext";

export default function CustomOrder() {
  const [showCart, setShowCart] = useState(false);
  const [customOrder, setCustomOrder] = useState(null);

  const {  setCustomOrderRes, customOrderID } =
    useContext(TailoringContext);

  const { handleGetNotification } = useAuth();

  const { userData } = useContext(UserContext);
  const user = userData?.user || {};
  const first_name = user?.first_name;
  const last_name = user?.last_name;
  const email = user?.email;

  const { handleAddToCart } = useTailoring();

  const navigate = useNavigate();

  useEffect(() => {
    handleGetNotification().then((res) => {
      setCustomOrder(res?.data?.custom_order_notification);
    });
    // eslint-disable-next-line
  }, []);

  const addToCart = (values) => {
    const payload = {
      values,
      id: customOrderID,
    };
    handleAddToCart(payload).then((res) => {
      setCustomOrderRes(res?.data.response);
    });
  };

  const formik = useFormik({
    initialValues: {
      delivery: "",
      delivery_address: "",
      email,
      first_name,
      last_name,
      from_state: "abuja",
      lga: "",
      pick_up: "",
      quantity: 1,
      size: "",
      to_state: "",
      whatsapp_number: "",
    },
    onSubmit(values) {
      addToCart(values);
    },
  });

  return (
    <>
      <form>
        <div className="product col-12">
          {customOrder?.map((item, idx) => (
            <div className="product_banner col-12" key={idx}>
              <CustomStyle {...{ orderImage: item.image_url }} />

              <div className="p_div">
                <div className="p_description">
                  <p>{item?.name}</p>
                  <p></p>

                  <p>₦{item?.price}</p>
                  
                  <p className="p_content text-capitalize">{item?.desc}</p>

                  <div className="custom_form">
                    <CustomForm {...{ formik }} />
                  </div>
                  <div className="div_btn">
                    <ButtonContainer
                      type="submit"
                      onClick={() => {
                        navigate("/tailoring/customordersummary", {
                          state: {
                            src: item.image_url,
                            id: 1,
                            stylename: item.name,
                            uniqueId: item._id,
                            description: item.desc,
                            price: item.price,
                            duration: item.duration,
                          },
                        });
                      }}
                    >
                      Proceed to Pay
                    </ButtonContainer>

                    <ButtonContainer type="button" cart>
                      <img alt="" src={Bag} /> <span>Add to Cart</span>
                    </ButtonContainer>
                  </div>
                  <div className="vector_div">
                    <span>
                      <img alt="" src={Vector} />
                      <span>Fit Guarantee</span>
                    </span>
                  </div>
                  <div className="fabric_desc">
                    <div className="dbr"></div>
                    <p>Duration: {item?.duration} days</p>
                  </div>
                  <div className="fabric_des">
                    <p>Fabric: Olympia, Multi Colored Ankara</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </form>
      <div className={showCart ? "cart-menu-expanded" : "cart-menu"}>
        <div>
          <AddToCart {...{ setShowCart }} />
        </div>
      </div>
    </>
  );
}
